import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;
const appUrl = import.meta.env.VITE_APP_URL || 'https://surf-snap.com';

// Create a custom fetch implementation with proper headers
const customFetch = (url: RequestInfo, options: RequestInit = {}) => {
  const headers = new Headers(options.headers);
  
  // Add client info header
  headers.set('X-Client-Info', 'surfphoto-hub');
  
  // Determine if this is a file upload request
  const isFileUpload =
    url.toString().includes("/storage/v1/object") &&
    !url.toString().includes("/sign/") &&
    options.method !== "DELETE" &&
    (options.body instanceof FormData || options.body instanceof Blob);

  
  if (isFileUpload) {
    // For file uploads, don't set any content type - let the browser set it
    // based on the FormData boundary
    if (headers.has("Content-Type")) {
      headers.delete("Content-Type");
    }
    if (import.meta.env.DEV) {
      console.log("File upload detected:", {
        url: url.toString(),
        method: options.method,
        bodyType: options.body
          ? options.body instanceof FormData
            ? "FormData"
            : options.body instanceof Blob
            ? "Blob"
            : typeof options.body
          : null,
      });
    }
  } else {
    // For non-file uploads, set JSON content type
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
  }
  
  // Log requests in development for debugging
  if (import.meta.env.DEV) {
    const method = options.method || 'GET';
    const urlStr = typeof url === 'string' ? url : url.toString();
    console.debug(`${method} request to ${urlStr}`, {
      isFileUpload,
      headers: Object.fromEntries(headers.entries()),
      contentLength: options.body instanceof FormData 
        ? '[FormData]' 
        : options.body?.toString().length
    });
  }
  
  return fetch(url, {
    ...options,
    headers
  });
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: customFetch
  }
});

export const APP_URL = appUrl;

// Add debug wrapper for queries
if (import.meta.env.DEV) {
  const originalFrom = supabase.from;
  supabase.from = function(table) {
    const query = originalFrom.call(this, table);
    
    const originalEq = query.eq;
    query.eq = function(column, value) {
      if (value === undefined) {
        console.warn(`WARNING: Undefined value detected for column "${column}" in table "${table}"`);
        console.trace();
      }
      return originalEq.call(this, column, value);
    };
    
    return query;
  };
}